// Global Instructions Rule Applied!
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { recordView } from '../state/mobileRecentsSlice.ts'

/**
 * Records a "recently viewed" entry once a mobile detail screen's record has resolved.
 * A no-op until both `id` and a non-empty `title` are present, so it fires exactly once
 * when the record lands — whether that record came from the slice cache or a cold detail
 * RPC. Each of the four detail screens calls this directly (FundScreen too, via its own
 * dashboard hook), keeping `useRecordDetail`'s contract untouched.
 */
export function useRecordRecent(
  module: string,
  id: string | number | null | undefined,
  title: unknown,
  subtitle?: unknown
): void {
  const dispatch = useDispatch()
  const t = title === null || title === undefined ? '' : String(title).trim()
  const s = subtitle === null || subtitle === undefined ? '' : String(subtitle).trim()

  useEffect(() => {
    if (!id || !t) return
    dispatch(recordView({ id: String(id), module, title: t, subtitle: s || undefined }))
  }, [module, id, t, s, dispatch])
}
